import React, { Component } from "react";
import {
  Card,
  ModalHeader
} from "reactstrap";

export default class ImageCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div>
        <ModalHeader toggle={this.props.goBack} />
        <Card
          style={{
            display: "flex",
            margin: 10,
            color: "black",
            justifyContent: "center",
            alignItems: "center",
            background: "transparent",
            padding: "12px"
          }}
        >
          <img
            style={{ objectFit: "contain", height: "100%", width: 300 }}
            src={this.props.image}
            alt = {''}
          />
        </Card>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageCard/ImageCard.js